import { z } from "zod";

import { AssignedToSchema } from "@/dashboard/features/hub/lib/customer/assignments/schemas";
import { CustomerContactInfoType } from "@/dashboard/features/hub/lib/customer/types";
import { BadgeSchema } from "@/dashboard/features/hub/lib/customer/ui/badge";
import { makePageSchema } from "@/dashboard/lib/query/pagination";
import { HubStatus, HubTab } from "@/dashboard/types/hub";
import { InteractionType, InteractionTypeDisplay } from "@/dashboard/types/interaction";

export const CustomerContactInfoSchema = z.object({
  type: z
    .string()
    .refine(
      (val): val is CustomerContactInfoType =>
        Object.values(CustomerContactInfoType).includes(val as CustomerContactInfoType),
      { message: "Invalid contact info type" }
    ),
  value: z.string(),
  unmasked_number: z.string().optional(),
});
export type CustomerContactInfo = z.infer<typeof CustomerContactInfoSchema>;

export const CustomerCoreSchema = z.object({
  id: z.string(),
  contact_info: CustomerContactInfoSchema,
  display_name: z.string(),
  hub_status: z.enum([HubStatus.NONE, HubStatus.FLAGGED]),
  hub_tab: z.nativeEnum(HubTab),
  interaction_type_display: z.nativeEnum(InteractionTypeDisplay),
});

export const CustomerRowSchema = CustomerCoreSchema.extend({
  badge: BadgeSchema.optional(),
  event_type: z.string().optional(),
  interaction_type: z.nativeEnum(InteractionType),
  digital_lead_source: z.string().optional(),
  campaign_id: z.string().optional(),
  analytics_business_unit_id: z.number().optional(),
  interaction_at: z.string().datetime(),
  is_active: z.boolean(),
  is_flagged: z.boolean(),
  is_transferred: z.boolean(),
  is_transferred_internally: z.boolean(),
  is_unseen: z.boolean(),
  tenant_id: z.string(),
  tenant_name: z.string(),
  tenant_name_abbreviation: z.string().nullable(),
  assigned_to: AssignedToSchema.optional(),
  // Lean list reads omit these decorations; folder and text filters still run in SQL.
  folder_ids: z.array(z.string()).optional(),
  has_unresponded_text: z.boolean().nullable().optional(),
});
export type CustomerRow = z.infer<typeof CustomerRowSchema>;

export const CustomerPageResponseSchema = makePageSchema(CustomerRowSchema);
export type CustomerPageResponse = z.infer<typeof CustomerPageResponseSchema>;
